import PersistState from "./persist-state";

export default PersistState;